import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';

const ProductDetailAttachments=({parentId,application,userData})=>{
    const list_name='product_attachments';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                application={application}
                userData={userData}
                entityType={'Attachment'}
                entityParams={['parent_id='+parentId,'table_name=product','_lang='+application.globalData.lang]}
                list_name={list_name}
                file={'ProductDetailAttachments.js'}
                initialState={{}}
                navigateOnNew={null}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                popupComponent={COMPONENT_MAP['AttachmentUploadPopup']}
                popupComponentQuery={['table_name=product']}
                parentContext={{parent_field_name:'parent_id',parent_field_value:null,parent_name:'Product'}}
                executeQuery={executeQuery}
                defaultQuickSearchColumns={['document_type','description']}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return(renderListTab);
}
export default ProductDetailAttachments;
